import { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import styles from "./UnitPriceForm.module.css";
import { FaEdit } from "react-icons/fa";

const T2RangeEdit = ({ unitPrices }) => {
  const [showCard, setShowCard] = useState(false);
  const [unitPriceForms, setUnitPriceForms] = useState([
    {
      type: "new",
      StartRange: "0",
      EndRange: "",
      Steps: "1",
    },
  ]);

  useEffect(() => {
    if (unitPrices && unitPrices.length) {
      const withIds = unitPrices.map((u, i) => ({
        ...u,
        type: "existing",
        changed_unitprice: u.changed_unitprice ?? false,
      }));
      setUnitPriceForms(withIds);
    }
  }, [showCard, unitPrices]);

  return (
    <div className={styles.container}>
      <button
        className={styles.EditUnitPrice}
        onClick={(e) => {
          e.preventDefault();
          setShowCard(true);
        }}
        aria-haspopup="dialog"
        aria-expanded={showCard}
      >
        <FaEdit />
      </button>
      {showCard && (
        <div className={styles.unitPriceContainer}>
          <div
            className={styles.dropShadow}
            onClick={() => setShowCard(false)}
            aria-hidden="true"
          />
          <div
            className={styles.unitPricefield}
            role="dialog"
            aria-modal="true"
            aria-label="Unit Prices"
            onKeyDown={(e) => {
              if (e.key === "Escape") setShowCard(false);
            }}
          >
            <div className={styles.unitBody}>
              {unitPriceForms.length !== 0 ? (
                <>
                  {unitPriceForms.map((form, index) => (
                    <Form
                      key={index}
                      className={styles.card}
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <div className={styles.unitPriceTop}>
                        <h1 className={styles.heading}>Unit Price</h1>
                      </div>
                      <div className={styles.cardBody}>
                        <Row>
                          <Col md={4}>
                            <Form.Group controlId={`formStartRange-${index}`}>
                              <Form.Label className={styles.unitPriceLabel}>
                                Start Range
                              </Form.Label>
                              <Form.Control
                                readOnly
                                type="number"
                                name="StartRange"
                                value={form.StartRange}
                                placeholder="Start Range"
                                className={`${styles.formControl}`}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formEndRange-${index}`}>
                              <Form.Label className={styles.unitPriceLabel}>
                                End Range (Must be Greater than Start Range)
                              </Form.Label>
                              <Form.Control
                                readOnly
                                type="number"
                                name="EndRange"
                                value={form.EndRange}
                                placeholder="End Range"
                                className={`${styles.formControl}`}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formStartRange-${index}`}>
                              <Form.Label className={styles.unitPriceLabel}>
                                Steps (Can't be more that the diff of StartRange
                                & EndRange i.e:{" "}
                                {parseInt(form.EndRange) -
                                  parseInt(form.StartRange)}{" "}
                                )
                              </Form.Label>
                              <Form.Control
                                readOnly
                                type="number"
                                name="Steps"
                                value={form.Steps}
                                placeholder="Steps"
                                className={`${styles.formControl} `}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </Form>
                  ))}
                </>
              ) : (
                <p>No Unit Price available</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default T2RangeEdit;
